import React, { useEffect } from 'react'
import { Container } from '@material-ui/core'
import RegisterForm from './RegisterForm'
import HeaderImage from '../../img/programmers-header-reverse.svg'
import FooterImage from '../../img/programmers-footer.svg'
import { Helmet } from 'react-helmet';

const Register = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - ثبت نام</title>
            </Helmet>

            <main id="register">
                <header id='section-1'>
                    <img src={HeaderImage} alt='' />
                </header>

                <Container maxWidth='sm'>
                    <section id='register-form'>
                        <RegisterForm />
                    </section>
                </Container>

            </main>
        </>
    )
}

export default Register